import { Customer } from './customer.interface';
import { DeliveryNote } from './deliverynotes.interface';
import { Product } from './product.interface';
import { Reservation } from './reservation.interface';

export interface Invoice {
  id?: number;
  type: InvoiceType;
  cancelled?: boolean | number;
  subtype: InvoiceSubType;
  invoice_number?: number;
  uuid?: string;
  customer_id: number;
  reservation_id: number;
  total_sum?: number;
  free_tokens?: number;
  pdf_filename?: string;
  sent_at?: string;
  dunning_at?: string;
  payed_at?: string;
  payed_with?: InvoicePayedWithType;
  dunning_amount?: number;
  created_at?: string;
  updated_at?: string;
  full_invoice_number?: string;
  customer?: Customer;
  reservation?: Reservation;
  invoice_id?: number;
  topup_products?: Product[];
  topup_amount?: number;
  tip_amount?: number;
  transaction_reference?: string;
  delivery_notes?: DeliveryNote[];
  storno?: Invoice;
}

export type InvoiceType = 'invoice' | 'storno';
export const InvoiceTypeMapper: Record<InvoiceType, string> = {
  invoice: 'Rechnung',
  storno: 'Storno',
};

export type InvoiceSubType = 'full' | 'voucher' | 'mark' | 'nocalc' | 'topup';
export const InvoiceSubTypeMapper: Record<InvoiceSubType, string> = {
  full: 'Rechnung',
  voucher: 'Gesamtwertscheck',
  mark: 'Markenverkauf',
  nocalc: 'Ohne Berechnung',
  topup: 'Top-Up Rechnung',
};

export type InvoiceStatusType = 'payed' | 'nonpayed';

export type InvoicePayedWithType =
  | 'transfer'
  | 'cash'
  | 'eccard'
  | 'creditcard'
  | 'none';

export const InvoicePayedWithTypeMapper: Record<InvoicePayedWithType, string> =
  {
    transfer: 'Überweisung',
    cash: 'Bar',
    eccard: 'EC Karte',
    creditcard: 'Kredit Karte',
    none: 'Ohne',
  };

export interface InvoiceSearchParams {
  festivalId?: number;
  invoiceType?: InvoiceType;
  invoiceSubType?: InvoiceSubType;
  isPayed?: boolean;
  olderThan?: number;
  order?: 'asc' | 'desc';
}
